import React, { useState, useEffect, useRef, useContext } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { isNil } from "lodash";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import FacebookIcon from '@material-ui/icons/Facebook';
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import TelegramIcon from "@material-ui/icons/Telegram";
import StarIcon from "@material-ui/icons/Star";
import GroupIcon from "@material-ui/icons/Group";
import HeadsetIcon from "@material-ui/icons/Headset";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import VpnLockIcon from "@material-ui/icons/VpnLock";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import ColorizeIcon from "@material-ui/icons/Colorize";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import ExtensionIcon from "@material-ui/icons/Extension";
import PhoneInTalkIcon from "@material-ui/icons/PhoneInTalk";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import ChatIcon from "@material-ui/icons/Chat";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import TimerIcon from "@material-ui/icons/Timer";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import FeedbackIcon from "@material-ui/icons/Feedback";
import TuneIcon from "@material-ui/icons/Tune";
import AndroidIcon from "@material-ui/icons/Android";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import moment from "moment";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Switch,
  Grid,
  Tab,
  Tabs,
  Paper,
  Box,
  Typography,
  FormHelperText,
  Tooltip,
} from "@material-ui/core";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import QueueSelect from "../QueueSelect";
import TabPanel from "../TabPanel";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import SchedulesForm from "../SchedulesForm";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import ColorPicker from "../ColorPicker";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import getRandomHexColor from "../../utils/getRandomHexColor";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
  },

  multFieldLine: {
    marginTop: 12,
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },

  btnWrapper: {
    position: "relative",
  },
  importMessage: {
    marginTop: 12,
    marginBottom: 12,
    paddingBottom: 20,
    paddingTop: 3,
    padding: 12,
    border: "solid grey 2px",
    borderRadius: 4,
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },

  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },
  tokenRefresh: {
    minWidth: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  colorAdorment: {
    width: 22,
    height: 22,
    borderRadius: 5,
    border: theme.palette.type === "light" ? "1px solid rgba(0, 0, 0, 0.2)" : "1px solid rgba(255, 255, 255, 0.2)",
  },
  customScrollbar: {
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.type === "light" 
        ? `${theme.palette.primary.main}80` 
        : `${theme.palette.primary.main}66`,
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: theme.palette.primary.main,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
      margin: "8px 0",
    },
  },
  formControl: {
    width: "100%",
  },
  colorField: {
    width: "100%",
  },

  // --- NUEVO SISTEMA DE DISEÑO (ESTILO USERMODAL) ---
  identityCard: {
    padding: "16px 18px",
    borderRadius: 12,
    backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.02)" : "rgba(255, 255, 255, 0.03)",
    border: theme.palette.type === "light" ? "1px solid rgba(0, 0, 0, 0.08)" : "1px solid rgba(255, 255, 255, 0.07)",
    marginBottom: 16,
  },
  channelAvatar: {
    width: 54,
    height: 54,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    border: "2px solid",
    transition: "all 0.3s ease",
  },
  channelBadge: {
    fontSize: "0.68rem",
    fontWeight: 700,
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    marginTop: 6,
    color: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.6)",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    margin: "18px 0 10px 0",
    paddingBottom: 6,
    borderBottom: theme.palette.type === "light" ? "1px solid rgba(0, 0, 0, 0.08)" : "1px solid rgba(255, 255, 255, 0.07)",
  },
  sectionTitle: {
    fontSize: "0.75rem",
    fontWeight: 700,
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    color: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.7)",
  },
  permCard: {
    display: "flex",
    alignItems: "center",
    padding: "10px 14px",
    borderRadius: 10,
    backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.02)" : "rgba(255, 255, 255, 0.03)",
    border: theme.palette.type === "light" ? "1px solid rgba(0, 0, 0, 0.08)" : "1px solid rgba(255, 255, 255, 0.07)",
    transition: "all 0.2s ease",
    cursor: "pointer",
    userSelect: "none",
    height: "100%",
    boxSizing: "border-box",
    "&:hover": {
      backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.04)" : "rgba(255, 255, 255, 0.06)",
      borderColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.2)" : "rgba(255, 255, 255, 0.18)",
      transform: "translateY(-1px)",
    },
  },
  permCardChecked: {
    border: "1px solid rgba(0, 168, 255, 0.4)",
    backgroundColor: theme.palette.type === "light" ? "rgba(0, 168, 255, 0.08)" : "rgba(0, 168, 255, 0.06)",
    "&:hover": {
      backgroundColor: theme.palette.type === "light" ? "rgba(0, 168, 255, 0.12)" : "rgba(0, 168, 255, 0.09)",
      borderColor: "rgba(0, 168, 255, 0.6)",
    },
  },
  permIconWrap: {
    width: 36,
    height: 36,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
    flexShrink: 0,
  },
  permTextWrap: {
    flex: 1,
    minWidth: 0,
    marginRight: 8,
  },
  permTitle: {
    fontSize: "0.82rem",
    fontWeight: 600,
    color: theme.palette.type === "light" ? "#2f3542" : "#f1f2f6",
    lineHeight: 1.25,
    marginBottom: 2,
  },
  permDesc: {
    fontSize: "0.7rem",
    color: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.55)",
    lineHeight: 1.25,
  },
  permSwitchWrap: {
    flexShrink: 0,
  },
  routingCard: {
    padding: "14px 16px",
    borderRadius: 10,
    backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.02)" : "rgba(255, 255, 255, 0.03)",
    border: theme.palette.type === "light" ? "1px solid rgba(0, 0, 0, 0.08)" : "1px solid rgba(255, 255, 255, 0.07)",
    marginBottom: 10,
  },
  tokenCard: {
    padding: "14px 16px",
    borderRadius: 10,
    backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.02)" : "rgba(255, 255, 255, 0.03)",
    border: theme.palette.type === "light" ? "1px solid rgba(0, 0, 0, 0.08)" : "1px solid rgba(255, 255, 255, 0.07)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
  },
  tokenCode: {
    fontFamily: "monospace",
    fontSize: "0.84rem",
    padding: "8px 14px",
    borderRadius: 6,
    backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(0, 0, 0, 0.35)",
    border: theme.palette.type === "light" ? "1px solid rgba(0, 0, 0, 0.1)" : "1px solid rgba(255, 255, 255, 0.1)",
    letterSpacing: "0.6px",
    color: theme.palette.type === "light" ? "#2c3e50" : "#a4b0be",
    wordBreak: "break-all",
    flex: 1,
    minWidth: 200,
  },
  tokenActions: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  quickBtn: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.78rem",
    borderRadius: 8,
    padding: "6px 14px",
  },
  cardBox: {
    padding: "16px 18px",
    borderRadius: 10,
    backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.02)" : "rgba(255, 255, 255, 0.03)",
    border: theme.palette.type === "light" ? "1px solid rgba(0, 0, 0, 0.08)" : "1px solid rgba(255, 255, 255, 0.07)",
    marginBottom: 14,
    transition: "all 0.2s ease",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: 14,
  },
  cardHeaderTitle: {
    fontSize: "0.86rem",
    fontWeight: 600,
    color: theme.palette.type === "light" ? "#2f3542" : "#f1f2f6",
    lineHeight: 1.25,
  },
  cardHeaderDesc: {
    fontSize: "0.72rem",
    color: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.55)",
    lineHeight: 1.25,
    marginTop: 2,
  },
  mainPaper: {
    borderBottom: theme.palette.type === "light" ? "1px solid rgba(0, 0, 0, 0.08)" : "1px solid rgba(255, 255, 255, 0.08)",
    backgroundColor: "transparent",
    marginBottom: 4,
  },
  tabsRoot: {
    minHeight: 48,
    width: "100%",
  },
  tabItem: {
    minHeight: 48,
    minWidth: "auto",
    maxWidth: "none",
    flex: 1,
    padding: "6px 8px",
    textTransform: "none",
    transition: "all 0.2s ease",
  },
}));

const SessionSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  brandId: Yup.mixed()
    .test(
      "required-brand",
      () => i18n.t("whatsappModal.validations.brandRequired") || "Debe seleccionar una marca obligatoriamente",
      (val) => val !== null && val !== undefined && val !== "" && Number(val) > 0
    )
    .required(() => i18n.t("whatsappModal.validations.brandRequired") || "Debe seleccionar una marca obligatoriamente"),
  sendIdQueue: Yup.mixed()
    .test(
      "required-queue",
      () => i18n.t("whatsappModal.errorSendQueue") || "Debe seleccionar una fila obligatoriamente",
      (val) => val !== null && val !== undefined && val !== "" && Number(val) > 0
    )
    .required(() => i18n.t("whatsappModal.errorSendQueue") || "Debe seleccionar una fila obligatoriamente"),
});

const WhatsAppModal = ({ open, onClose, whatsAppId, channel }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [autoToken, setAutoToken] = useState("");
  const [isExchangingCode, setIsExchangingCode] = useState(false);

  const inputFileRef = useRef(null);

  const [attachment, setAttachment] = useState(null);
  const [attachmentName, setAttachmentName] = useState("");

  const initialState = {
    name: "",
    brandId: "",
    greetingMessage: "",
    complationMessage: "",
    outOfHoursMessage: "",
    ratingMessage: "",
    isDefault: false,
    connectionEngine: "baileys",
    token: "",
    maxUseBotQueues: 3,
    provider: "beta",
    expiresTicket: 0,
    allowGroup: false,
    enableImportMessage: false,
    groupAsTicket: "disabled",
    timeUseBotQueues: "5",
    timeSendQueue: "0",
    sendIdQueue: 0,
    expiresTicketNPS: "0",
    expiresInactiveMessage: "",
    timeInactiveMessage: "",
    inactiveMessage: "",
    maxUseBotQueuesNPS: 3,
    whenExpiresTicket: 0,
    timeCreateNewTicket: 0,
    greetingMediaAttachment: "",
    importRecentMessages: "",
    importOldMessages: "",
    importOldMessagesGroups: "",
    integrationId: "",
    collectiveVacationEnd: "",
    collectiveVacationStart: "",
    collectiveVacationMessage: "",
    queueIdImportMessages: null,
    isOficial: false,
    phone_number_id: "",
    waba_id: "",
    send_token: "",
    business_id: "",
    phone_number: "",
    color: getRandomHexColor(),
    flowInactiveTime: 0,
    flowIdInactiveTime: 0,
    timeAwaitActiveFlowId: 0,
    maxUseInactiveTime: 1,
    timeToReturnQueue: 0,
    triggerIntegrationOnClose: false,
    wavoip: "",
    flowIdWelcome: "DISABLED",
    flowIdNotPhrase: "DISABLED",
    enableListenFromMe: false,
    proxyUrl: "",
    rejectCalls: false,
    rejectCallMessage: "",
  };
  const [whatsApp, setWhatsApp] = useState(initialState);
  const [brands, setBrands] = useState([]);
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);
  const [queues, setQueues] = useState([]);
  const [tab, setTab] = useState("general");
  const [enableImportMessage, setEnableImportMessage] = useState(false);
  const [importOldMessagesGroups, setImportOldMessagesGroups] = useState(false);
  const [closedTicketsPostImported, setClosedTicketsPostImported] =
    useState(false);
  const [importOldMessages, setImportOldMessages] = useState(
    moment().add(-1, "days").format("YYYY-MM-DDTHH:mm")
  );
  const [importRecentMessages, setImportRecentMessages] = useState(
    moment().add(-1, "minutes").format("YYYY-MM-DDTHH:mm")
  );
  const [copied, setCopied] = useState(false);
  const [integrations, setIntegrations] = useState([]);
  const [schedulesEnabled, setSchedulesEnabled] = useState(false);
  const [NPSEnabled, setNPSEnabled] = useState(false);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const { user } = useContext(AuthContext);
  const [isOficial, setIsOficial] = useState(false);
  const [useWhatsappOfficial, setUseWhatsappOfficial] = useState(false);
  const [colorPickerModalOpen, setColorPickerModalOpen] = useState(false);

  const [schedules, setSchedules] = useState([
    {
      weekday: i18n.t("queueModal.serviceHours.monday"),
      weekdayEn: "monday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.tuesday"),
      weekdayEn: "tuesday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.wednesday"),
      weekdayEn: "wednesday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.thursday"),
      weekdayEn: "thursday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.friday"),
      weekdayEn: "friday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.saturday"),
      weekdayEn: "saturday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.sunday"),
      weekdayEn: "sunday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
  ]);

  const { get: getSetting } = useCompanySettings();
  const { getPlanCompany } = usePlans();

  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [triggerIntegrationOnClose, setTriggerIntegrationOnClose] =
    useState(false);
  const [integrationType, setIntegrationType] = useState("n8n");
  const [integrationTypeId, setIntegrationTypeId] = useState(null);

  const [prompts, setPrompts] = useState([]);

  const [webhooks, setWebhooks] = useState([]);
  const [flowIdNotPhrase, setFlowIdNotPhrase] = useState();
  const [flowIdWelcome, setFlowIdWelcome] = useState();
  const [flowIdInactiveTime, setFlowIdInactiveTime] = useState();
  const [timeAwaitActiveFlowId, setTimeAwaitActiveFlowId] = useState();
  const [showWavoipCall, setShowWavoipCall] = useState(false);

  useEffect(() => {
    if (!whatsAppId && !whatsApp.token) {
      setAutoToken(generateRandomCode(30));
    } else if (whatsAppId && !whatsApp.token) {
      setAutoToken(generateRandomCode(30));
    } else {
      setAutoToken(whatsApp.token);
    }
  }, [whatsAppId, whatsApp.token, channel]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
      setUseWhatsappOfficial(planConfigs.plan.useWhatsappOfficial);
      setShowWavoipCall(planConfigs.plan.wavoip);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/prompt");
        setPrompts(data.prompts);
      } catch (err) {
        toastError(err);
      }
    })();
  }, [whatsAppId]);

  useEffect(() => {
    if (open) {
      (async () => {
        try {
          const { data } = await api.get("/flowbuilder");
          setWebhooks(data.flows);
        } catch (err) {
          toastError(err);
        }
      })();
    }
  }, [open]);

  useEffect(() => {
    const fetchData = async () => {
      const settingSchedules = await getSetting({
        column: "scheduleType",
      });
      setSchedulesEnabled(settingSchedules.scheduleType === "connection");
      const settingNPS = await getSetting({
        column: "userRating",
      });
      setNPSEnabled(settingNPS.userRating === "enabled");
    };
    fetchData();
  }, []);

  const handleEnableImportMessage = async (e) => {
    setEnableImportMessage(e.target.checked);
  };

  const handleEnableIsOficial = async (e) => {
    setIsOficial(e.target.checked);
  };


  useEffect(() => {
    if (open) {
      const fetchBrands = async () => {
        try {
          const { data } = await api.get('/brands');
          setBrands(data);
          // [Plan 1236] Preselección automática de Marca si es nueva conexión o no tiene marca asignada
          if (Array.isArray(data) && data.length > 0) {
            setWhatsApp((prev) => {
              if (!prev.brandId || prev.brandId === "" || !whatsAppId) {
                return {
                  ...prev,
                  brandId: prev.brandId && prev.brandId !== "" ? prev.brandId : data[0].id
                };
              }
              return prev;
            });
          }
        } catch (err) {
          console.error("Error fetching brands in WhatsAppModal:", err);
        }
      };
      fetchBrands();
    }
  }, [open, whatsAppId]);

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`whatsapp/${whatsAppId}?session=0`);

        if (data && data?.flowIdNotPhrase) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdNotPhrase}`
          );
          const selectedFlowIdNotPhrase = flowDefault?.flow.id;
          setFlowIdNotPhrase(selectedFlowIdNotPhrase);
        }

        if (data && data?.flowIdWelcome) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdWelcome}`
          );
          const selectedFlowIdWelcome = flowDefault?.flow.id;
          setFlowIdWelcome(selectedFlowIdWelcome);
        }

        if (data && data?.flowIdInactiveTime) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdInactiveTime}`
          );
          const selectedFlowIdInactiveTime = flowDefault?.flow.id;
          setFlowIdInactiveTime(selectedFlowIdInactiveTime);
        }

        if (data && data?.timeAwaitActiveFlowId) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.timeAwaitActiveFlowId}`
          );
          const selectedTimeAwaitActiveFlowId = flowDefault?.flow.id;
          setTimeAwaitActiveFlowId(selectedTimeAwaitActiveFlowId);
        }

        setWhatsApp(data);
        setAttachmentName(data.greetingMediaAttachment);
        setAutoToken(data.token);
        data.promptId
          ? setSelectedPrompt(data.promptId)
          : setSelectedPrompt(null);
        const whatsQueueIds = data.queues?.map((queue) => queue.id);
        setSelectedQueueIds(whatsQueueIds);
        setIsOficial(data.channel === "whatsapp_oficial");
        setSchedules(data.schedules);
        setTriggerIntegrationOnClose(data.triggerIntegrationOnClose);
        setIntegrationType(data.integrationType || "n8n");
        setIntegrationTypeId(data.integrationTypeId || null);
        if (!isNil(data?.importOldMessages)) {
          setEnableImportMessage(true);
          setImportOldMessages(data?.importOldMessages);
          setImportRecentMessages(data?.importRecentMessages);
          setClosedTicketsPostImported(data?.closedTicketsPostImported);
          setImportOldMessagesGroups(data?.importOldMessagesGroups);
        }
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    if (open) {
      (async () => {
        try {
          const { data } = await api.get("/queue");
          setQueues(data);
          if (!whatsAppId && data && data.length > 0) {
            setWhatsApp((prev) => {
              if (!prev.sendIdQueue || prev.sendIdQueue === 0) {
                const ventasQueue = data.find(
                  (q) => q.name && q.name.toLowerCase().includes("ventas")
                );
                return {
                  ...prev,
                  sendIdQueue: ventasQueue ? ventasQueue.id : data[0].id,
                };
              }
              return prev;
            });
          }
        } catch (err) {
          toastError(err);
        }
      })();
    }
  }, [open, whatsAppId]);

  useEffect(() => {
    if (open) {
      (async () => {
        try {
          const { data } = await api.get("/queueIntegration");

          setIntegrations(data.queueIntegrations);
        } catch (err) {
          toastError(err);
        }
      })();
    }
  }, [open]);

  useEffect(() => {
    // Inicializar Facebook SDK para el Registro Insertado
    const initFB = () => {
      window.FB.init({
        appId            : process.env.REACT_APP_FACEBOOK_APP_ID || '1890261498306432',
        autoLogAppEvents : true,
        xfbml            : true,
        version          : 'v19.0'
      });
    };

    if (window.FB) {
      try { initFB(); } catch (e) {}
    } else {
      window.fbAsyncInit = initFB;
    }
  }, []);

  const handleFacebookLogin = (values, setValues) => {
    if (!window.FB) {
      toast.error(i18n.t("whatsappModal.messages.sdkError"));
      return;
    }

    window.FB.login((response) => {
      const processResponse = async () => {
        if (response.authResponse) {
          const code = response.authResponse.code;
        
        if (code) {
          try {
            setIsExchangingCode(true);
            toast.info(i18n.t("whatsappModal.messages.configuring"), { autoClose: 2000 });
            
            const { data } = await api.post("/whatsapp/embedded-signup", { code });
            
            if (data.accessToken && data.phoneNumberId && data.wabaId) {
              const defaultName = values.name ? values.name : (data.phoneNumber ? `Meta ${data.phoneNumber}` : `WhatsApp ${data.phoneNumberId.slice(-4)}`);
              
              // Asignar por defecto la fila "Ventas" si existe en las queues disponibles
              let defaultSendIdQueue = values.sendIdQueue;
              if ((!defaultSendIdQueue || defaultSendIdQueue === "" || defaultSendIdQueue === 0) && Array.isArray(queues) && queues.length > 0) {
                const ventasQueue = queues.find(q => q.name && q.name.toLowerCase().includes("ventas"));
                if (ventasQueue) {
                  defaultSendIdQueue = ventasQueue.id;
                  if (!selectedQueueIds.includes(Number(ventasQueue.id))) {
                    setSelectedQueueIds(prev => [...prev, Number(ventasQueue.id)]);
                  }
                } else {
                  defaultSendIdQueue = queues[0].id;
                }
              }

              const updatedValues = { 
                ...values, 
                name: defaultName,
                send_token: data.accessToken,
                phone_number_id: data.phoneNumberId,
                waba_id: data.wabaId,
                phone_number: data.phoneNumber || "",
                sendIdQueue: defaultSendIdQueue || values.sendIdQueue
              };

              setWhatsApp(prev => ({ 
                ...prev, 
                name: defaultName,
                send_token: data.accessToken,
                phone_number_id: data.phoneNumberId,
                waba_id: data.wabaId,
                phone_number: data.phoneNumber || "",
                sendIdQueue: defaultSendIdQueue || prev.sendIdQueue
              }));

              if (setValues) {
                setValues(updatedValues);
              }
              
              toast.success(i18n.t("whatsappModal.messages.authSuccess"));
              
              // Solo guardar automáticamente si la marca ya está seleccionada previamente (ej. al editar conexión existente)
              if (updatedValues.brandId && updatedValues.brandId !== "" && Number(updatedValues.brandId) > 0) {
                handleSaveWhatsApp(updatedValues);
              } else {
                toast.info(i18n.t("whatsappModal.identity.selectBrandToComplete") || "WhatsApp Oficial vinculado con éxito. Selecciona la Marca requerida y presiona Guardar.");
              }
              
            } else {
               toast.error(i18n.t("whatsappModal.messages.authError"));
            }
          } catch (error) {
            console.error("Error exchanging code:", error);
            toastError(error);
          } finally {
            setIsExchangingCode(false);
          }
        }
      } else {
        toast.error(i18n.t("whatsappModal.messages.authCanceled"));
      }
    };
    processResponse();
  }, {
      config_id: process.env.REACT_APP_FACEBOOK_CONFIG_ID || '1082564194472276',
      response_type: 'code',
      override_default_response_type: true,
      extras: {
        featureType: 'whatsapp_business_app_onboarding',
        sessionInfoVersion: '3'
      }
    });
  };

  const handleChangeQueue = (e) => {
    setSelectedQueueIds(e);
    setSelectedPrompt(null);
  };

  const handleChangePrompt = (e) => {
    setSelectedPrompt(e.target.value);
    setSelectedQueueIds([]);
  };

  const handleChange = (e) => {
    setTriggerIntegrationOnClose(e.target.value);
  };

  const handleIntegrationTypeChange = (e) => {
    setIntegrationType(e.target.value);
    setIntegrationTypeId(e.target.value);
  };

  const handleSaveWhatsApp = async (values) => {
    // [Plan 1236] Asignación de respaldo si la marca no estaba seleccionada pero existen marcas
    if ((!values.brandId || values.brandId === "" || Number(values.brandId) <= 0) && brands.length > 0) {
      values.brandId = brands[0].id;
    }

    if (!values.brandId || values.brandId === "" || Number(values.brandId) <= 0) {
      toast.error(i18n.t("whatsappModal.validations.brandRequired") || "La Marca es un campo obligatorio.");
      return;
    }

    if (!whatsAppId) setAutoToken(generateRandomCode(30));

    if (NPSEnabled) {
      if (isNil(values.ratingMessage)) {
        toastError(i18n.t("whatsappModal.errorRatingMessage"));
        return;
      }

      if (
        values.expiresTicketNPS === "0" &&
        values.expiresTicketNPS === "" &&
        values.expiresTicketNPS === 0
      ) {
        toastError(i18n.t("whatsappModal.errorExpiresNPS"));
        return;
      }
    }

    if (values.timeSendQueue === "") values.timeSendQueue = "0";

    const whatsappData = {
      ...values,
      flowIdWelcome: values.flowIdWelcome === "DISABLED" ? null : values.flowIdWelcome,
      flowIdInactiveTime: values.flowIdInactiveTime ? values.flowIdInactiveTime : null,
      flowIdNotPhrase: values.flowIdNotPhrase === "DISABLED" ? null : values.flowIdNotPhrase,
      timeAwaitActiveFlowId: values.timeAwaitActiveFlowId ? values.timeAwaitActiveFlowId : null,
      queueIds: (() => {
        const ids = Array.isArray(selectedQueueIds) ? [...selectedQueueIds] : [];
        if (values.sendIdQueue && !ids.includes(Number(values.sendIdQueue))) {
          ids.push(Number(values.sendIdQueue));
        }
        return ids;
      })(),
      importOldMessages: enableImportMessage ? importOldMessages : null,
      importRecentMessages: enableImportMessage ? importRecentMessages : null,
      importOldMessagesGroups: importOldMessagesGroups
        ? importOldMessagesGroups
        : null,
      closedTicketsPostImported: closedTicketsPostImported
        ? closedTicketsPostImported
        : null,
      token: channel === "telegram" ? values.token : (autoToken ? autoToken : null),
      schedules,
      promptId: selectedPrompt ? selectedPrompt : null,
      channel,
      triggerIntegrationOnClose: triggerIntegrationOnClose,
      integrationTypeId: triggerIntegrationOnClose ? integrationTypeId : null,
      color: values.color ? values.color : getRandomHexColor(),
      wavoip: values.wavoip ? values.wavoip : null,
      enableListenFromMe: values.enableListenFromMe,
      status: channel === "whatsapp_oficial" ? (isOficial ? "CONNECTED" : "DISCONNECTED") : whatsApp.status,
    };
    delete whatsappData["queues"];
    delete whatsappData["session"];

    try {
      if (whatsAppId) {
        if (
          whatsAppId &&
          enableImportMessage &&
          whatsApp?.status === "CONNECTED" &&
          channel !== "whatsapp_oficial"
        ) {
          try {
            setWhatsApp({ ...whatsApp, status: "qrcode" });
            await api.delete(`/whatsappsession/${whatsApp.id}`);
          } catch (err) {
            console.error("Error deleting session on import", err);
          }
        }

        await api.put(`/whatsapp/${whatsAppId}`, whatsappData);
        if (attachment != null) {
          try {
            const formData = new FormData();
            formData.append("file", attachment);
            await api.post(`/whatsapp/${whatsAppId}/media-upload`, formData);
          } catch (err) {
            console.error("[ANTIGRAVITY] Error uploading attachment:", err);
          }
        }
        if (!attachmentName && whatsApp.greetingMediaAttachment) {
          try {
            await api.delete(`/whatsapp/${whatsAppId}/media-upload`);
          } catch (err) {
            console.error("[ANTIGRAVITY] Error deleting attachment:", err);
          }
        }
      } else {
        const { data } = await api.post("/whatsapp", whatsappData);
        if (attachment != null) {
          try {
            const formData = new FormData();
            formData.append("file", attachment);
            await api.post(`/whatsapp/${data.id}/media-upload`, formData);
          } catch (err) {
            console.error("[ANTIGRAVITY] Error uploading attachment on create:", err);
          }
        }
      }
      toast.success(i18n.t("whatsappModal.success"));
      handleClose();
    } catch (err) {
      console.error("[ANTIGRAVITY] handleSaveWhatsApp error:", err);
      toastError(err);
    }
  };

  function generateRandomCode(length) {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyvz0123456789";
    let code = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      code += charset.charAt(randomIndex);
    }
    return code;
  }

  const handleRefreshToken = () => {
    setAutoToken(generateRandomCode(30));
  };

  const handleChangeFlowIdNotPhrase = (e) => {
    console.log(e.target.value);
    setFlowIdNotPhrase(e.target.value);
  };

  const handleChangeFlowIdWelcome = (e) => {
    setFlowIdWelcome(e.target.value);
  };

  const handleChangeFlowIdInactiveTime = (e) => {
    setFlowIdInactiveTime(e.target.value);
  };

  const handleChangeTimeAwaitActiveFlowId = (e) => {
    setTimeAwaitActiveFlowId(e.target.value);
  };

  const handleCopyToken = () => {
    if (autoToken) {
      navigator.clipboard.writeText(autoToken);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2500);
    }
  };

  const handleSaveSchedules = async (values) => {
    toast.success(i18n.t("common.toasts.clickToSave"));
    setSchedules(values);
  };

  const handleClose = () => {
    setWhatsApp(initialState);
    setEnableImportMessage(false);
    setAttachment(null);
    setAttachmentName("");
    setCopied(false);
    setTriggerIntegrationOnClose(false);
    setIntegrationType("n8n");
    setIntegrationTypeId(null);
    setIsOficial(false);
    // [ANTIGRAVITY] Call onClose last to ensure states are cleared before unmounting logic kicks in
    onClose();
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const TAB_DEFINITIONS = {
    general: {
      color: "#00E676",
      Icon: TuneIcon,
      labelKey: "whatsappModal.tabs.general",
    },
    integrations: {
      color: "#00E5FF",
      Icon: ExtensionIcon,
      labelKey: "whatsappModal.tabs.integrations",
    },
    messages: {
      color: "#FFD600",
      Icon: ChatIcon,
      labelKey: "whatsappModal.tabs.messages",
    },
    chatbot: {
      color: "#FF6D00",
      Icon: AndroidIcon,
      labelKey: "whatsappModal.tabs.chatbot",
    },
    nps: {
      color: "#D500F9",
      Icon: StarIcon,
      labelKey: "whatsappModal.tabs.assessments",
    },
    flowbuilder: {
      color: "#FF4081",
      Icon: AccountTreeIcon,
      labelKey: "whatsappModal.tabs.flowbuilder",
    },
    schedules: {
      color: "#00BFA5",
      Icon: AccessTimeIcon,
      labelKey: "whatsappModal.tabs.schedules",
    },
  };

  const renderTabLabel = (tabKey) => {
    const config = TAB_DEFINITIONS[tabKey];
    if (!config) return null;
    const { color, Icon, labelKey } = config;
    const isActive = tab === tabKey;
    const isDark = theme.palette.type === "dark";

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          color: isActive
            ? (isDark ? "#ffffff" : "#111827")
            : (isDark ? "rgba(255, 255, 255, 0.65)" : "rgba(0, 0, 0, 0.6)"),
          transition: "all 0.25s ease",
          userSelect: "none",
        }}
      >
        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 12px" }}>
          <Icon
            style={{
              marginRight: 8,
              color: color,
              filter: isActive ? `drop-shadow(0 0 3px ${color})` : "none",
              opacity: isActive ? 1 : 0.65,
              fontSize: "1.35rem",
              transition: "all 0.25s ease",
            }}
          />
          <span style={{
            fontWeight: isActive ? 900 : 600,
            lineHeight: 1, // Previene expansión vertical al hacerse negrita
            textShadow: isActive ? (isDark ? "0 0 3px rgba(255, 255, 255, 0.4)" : "none") : "none",
            letterSpacing: "0.2px",
            whiteSpace: "nowrap",
          }}>
            {i18n.t(labelKey)}
          </span>
        </div>
        <div style={{
          height: 3,
          minHeight: 3,
          flexShrink: 0,
          width: "100%",
          backgroundColor: isActive ? color : "transparent",
          boxShadow: isActive ? `0 0 6px ${color}` : "none",
          borderRadius: "3px 3px 0 0",
          transition: "all 0.25s ease",
          marginBottom: isActive ? "2px" : "0px", // Evita recorte en el desbordamiento
        }} />
      </div>
    );
  };

  const handleFileUpload = () => {
    const file = inputFileRef.current.files[0];
    setAttachment(file);
    setAttachmentName(file.name);
    inputFileRef.current.value = null;
  };

  const handleDeleFile = () => {
    setAttachment(null);
    setAttachmentName(null);
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          {whatsAppId
            ? i18n.t("whatsappModal.title.edit")
            : i18n.t("whatsappModal.title.add")}
        </DialogTitle>
        <Formik
          initialValues={whatsApp}
          enableReinitialize={true}
          validationSchema={SessionSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveWhatsApp(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, touched, errors, isSubmitting, setFieldValue, setValues }) => (
            <Form style={{ display: "flex", flexDirection: "column", maxHeight: "calc(100vh - 120px)", overflow: "hidden" }}>
              <Paper className={classes.mainPaper} elevation={0}>
                <Tabs
                  value={tab}
                  onChange={handleTabChange}
                  variant="fullWidth"
                  indicatorColor="primary"
                  textColor="primary"
                  className={classes.tabsRoot}
                  TabIndicatorProps={{
                    style: { display: "none" }
                  }}
                >
                  <Tab
                    className={classes.tabItem}
                    label={renderTabLabel("general")}
                    value={"general"}
                  />
                  <Tab
                    className={classes.tabItem}
                    label={renderTabLabel("integrations")}
                    value={"integrations"}
                  />
                  <Tab
                    className={classes.tabItem}
                    label={renderTabLabel("messages")}
                    value={"messages"}
                  />
                  <Tab
                    className={classes.tabItem}
                    label={renderTabLabel("chatbot")}
                    value={"chatbot"}
                  />
                  <Tab
                    className={classes.tabItem}
                    label={renderTabLabel("nps")}
                    value={"nps"}
                  />
                  {user.showFlow === "enabled" && (
                    <Tab
                      className={classes.tabItem}
                      label={renderTabLabel("flowbuilder")}
                      value={"flowbuilder"}
                    />
                  )}
                  {schedulesEnabled && (
                    <Tab
                      className={classes.tabItem}
                      label={renderTabLabel("schedules")}
                      value={"schedules"}
                    />
                  )}
                </Tabs>
              </Paper>
              <Paper className={`${classes.paper} ${classes.customScrollbar}`} elevation={0} style={{ flex: "1 1 auto", minHeight: 0, overflowY: "auto", overflowX: "hidden" }}>
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"general"}
                >
                  <DialogContent dividers className={classes.customScrollbar}>
                    {/* CABECERA / IDENTIDAD DE LA CONEXIÓN */}
                    <Paper elevation={0} className={classes.identityCard}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid
                          item
                          xs={12}
                          sm={3}
                          md={2}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            className={classes.channelAvatar}
                            style={{
                              borderColor: values.color || "#25D366",
                              backgroundColor: `${values.color || "#25D366"}15`,
                              boxShadow: `0 0 14px ${values.color || "#25D366"}33`,
                            }}
                          >
                            {channel === "telegram" ? (
                              <TelegramIcon style={{ fontSize: 32, color: values.color || "#0088cc" }} />
                            ) : channel === "whatsapp_oficial" ? (
                              <VerifiedUserIcon style={{ fontSize: 32, color: values.color || "#25D366" }} />
                            ) : (
                              <WhatsAppIcon style={{ fontSize: 32, color: values.color || "#25D366" }} />
                            )}
                          </div>
                          <Typography className={classes.channelBadge}>
                            {channel === "whatsapp_oficial"
                              ? "Oficial Meta"
                              : channel === "telegram"
                              ? "Telegram"
                              : "WhatsApp"}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={9} md={10}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <FormControl
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                required
                                error={touched.brandId && Boolean(errors.brandId)}
                              >
                                <InputLabel id="brand-select-label">
                                  {i18n.t("whatsappModal.identity.brand") || "Marca Requerida"}
                                </InputLabel>
                                <Field
                                  as={Select}
                                  labelId="brand-select-label"
                                  id="brandId"
                                  name="brandId"
                                  label={i18n.t("whatsappModal.identity.brand") || "Marca Requerida"}
                                >
                                  <MenuItem value={""}>
                                    <em>{i18n.t("whatsappModal.identity.selectBrand") || "Seleccione una marca"}</em>
                                  </MenuItem>
                                  {brands.map((b) => (
                                    <MenuItem key={b.id} value={b.id}>
                                      {b.name}
                                    </MenuItem>
                                  ))}
                                </Field>
                                {brands.length === 0 && (
                                  <Typography variant="caption" color="error">
                                    {i18n.t("whatsappModal.identity.brandWarning") || "⚠️ Debes crear al menos una Marca primero."}
                                  </Typography>
                                )}
                              </FormControl>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <Field
                                as={TextField}
                                label={i18n.t("whatsappModal.identity.name") || i18n.t("whatsappModal.form.name")}
                                autoFocus
                                name="name"
                                error={touched.name && Boolean(errors.name)}
                                helperText={touched.name && errors.name}
                                variant="outlined"
                                margin="dense"
                                fullWidth
                              />
                            </Grid>

                            <Grid item xs={12} md={2}>
                              <Field
                                as={TextField}
                                label={i18n.t("whatsappModal.identity.color") || i18n.t("connections.table.color")}
                                name="color"
                                id="color"
                                fullWidth
                                onFocus={() => setColorPickerModalOpen(false)}
                                error={touched.color && Boolean(errors.color)}
                                helperText={touched.color && errors.color}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <div
                                        style={{ backgroundColor: values.color }}
                                        className={classes.colorAdorment}
                                      />
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <IconButton
                                      size="small"
                                      onClick={() => setColorPickerModalOpen(true)}
                                    >
                                      <ColorizeIcon fontSize="small" />
                                    </IconButton>
                                  ),
                                }}
                                variant="outlined"
                                margin="dense"
                              />
                              <ColorPicker
                                open={colorPickerModalOpen}
                                handleClose={() => setColorPickerModalOpen(false)}
                                onChange={(color) => {
                                  values.color = color;
                                  setWhatsApp(() => ({ ...values, color }));
                                }}
                              />
                            </Grid>

                            {channel === "whatsapp" && (
                              <Grid item xs={12}>
                                <FormControl variant="outlined" margin="dense" fullWidth>
                                  <InputLabel>
                                    {i18n.t("whatsappModal.identity.engine") || "Motor de Conexión"}
                                  </InputLabel>
                                  <Field
                                    as={Select}
                                    name="connectionEngine"
                                    label={i18n.t("whatsappModal.identity.engine") || "Motor de Conexión"}
                                  >
                                    <MenuItem value="baileys">
                                      {i18n.t("whatsappModal.identity.engineBaileys") || "Baileys (Predeterminado, Rápido)"}
                                    </MenuItem>
                                    <MenuItem value="puppeteer">
                                      {i18n.t("whatsappModal.identity.enginePuppeteer") || "Puppeteer (Navegador, Alta Compatibilidad)"}
                                    </MenuItem>
                                  </Field>
                                </FormControl>
                              </Grid>
                            )}

                            {/* IDs de solo lectura para API Oficial al editar */}
                            {whatsAppId && channel === "whatsapp_oficial" && (
                              <>
                                <Grid item xs={12}>
                                  <TextField
                                    label="Webhook URL"
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    value={`${process.env.REACT_APP_API_OFICIAL_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin}/v1/webhook/${user?.companyId}/${values?.waba_webhook_id || whatsAppId}`}
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: true }}
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField
                                    label={i18n.t("whatsappModal.form.companyId") || "ID Empresa"}
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    value={user?.companyId || ""}
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: true }}
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField
                                    label={i18n.t("whatsappModal.form.connectionId") || "ID Conexión"}
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    value={whatsAppId || ""}
                                    InputProps={{ readOnly: true }}
                                    InputLabelProps={{ shrink: true }}
                                  />
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Paper>

                    {/* COMPORTAMIENTO Y OPERACIÓN (ESTILO USERMODAL) */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.operations")}
                      </Typography>
                    </div>

                    <Grid container spacing={1.5} style={{ marginBottom: 16 }}>
                      {/* Conexión Predeterminada */}
                      <Grid item xs={12} sm={6}>
                        <Paper
                          elevation={0}
                          className={`${classes.permCard} ${values.isDefault ? classes.permCardChecked : ""}`}
                          onClick={() => setFieldValue("isDefault", !values.isDefault)}
                        >
                          <div
                            className={classes.permIconWrap}
                            style={{ color: "#00a8ff", backgroundColor: "#00a8ff18" }}
                          >
                            <StarIcon fontSize="small" />
                          </div>
                          <div className={classes.permTextWrap}>
                            <Typography className={classes.permTitle}>
                              {i18n.t("whatsappModal.operations.default.title")}
                            </Typography>
                            <Tooltip title={i18n.t("whatsappModal.operations.default.desc")} enterDelay={500} arrow>
                              <Typography className={classes.permDesc}>
                                {i18n.t("whatsappModal.operations.default.desc")}
                              </Typography>
                            </Tooltip>
                          </div>
                          <div className={classes.permSwitchWrap}>
                            <Switch
                              checked={Boolean(values.isDefault)}
                              color="primary"
                              onChange={(e) => setFieldValue("isDefault", e.target.checked)}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                        </Paper>
                      </Grid>

                      {/* Permitir Grupos (solo WhatsApp web/baileys) */}
                      {channel === "whatsapp" && (
                        <Grid item xs={12} sm={6}>
                          <Paper
                            elevation={0}
                            className={`${classes.permCard} ${values.allowGroup ? classes.permCardChecked : ""}`}
                            onClick={() => setFieldValue("allowGroup", !values.allowGroup)}
                          >
                            <div
                              className={classes.permIconWrap}
                              style={{ color: "#2ed573", backgroundColor: "#2ed57318" }}
                            >
                              <GroupIcon fontSize="small" />
                            </div>
                            <div className={classes.permTextWrap}>
                              <Typography className={classes.permTitle}>
                                {i18n.t("whatsappModal.operations.group.title")}
                              </Typography>
                              <Tooltip title={i18n.t("whatsappModal.operations.group.desc")} enterDelay={500} arrow>
                                <Typography className={classes.permDesc}>
                                  {i18n.t("whatsappModal.operations.group.desc")}
                                </Typography>
                              </Tooltip>
                            </div>
                            <div className={classes.permSwitchWrap}>
                              <Switch
                                checked={Boolean(values.allowGroup)}
                                color="primary"
                                onChange={(e) => setFieldValue("allowGroup", e.target.checked)}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </div>
                          </Paper>
                        </Grid>
                      )}

                      {/* Escuchar mis mensajes (Listen from me) */}
                      <Grid item xs={12} sm={6}>
                        <Paper
                          elevation={0}
                          className={`${classes.permCard} ${values.enableListenFromMe ? classes.permCardChecked : ""}`}
                          onClick={() => setFieldValue("enableListenFromMe", !values.enableListenFromMe)}
                        >
                          <div
                            className={classes.permIconWrap}
                            style={{ color: "#9b59b6", backgroundColor: "#9b59b618" }}
                          >
                            <HeadsetIcon fontSize="small" />
                          </div>
                          <div className={classes.permTextWrap}>
                            <Typography className={classes.permTitle}>
                              {i18n.t("whatsappModal.operations.listenFromMe.title")}
                            </Typography>
                            <Tooltip title={i18n.t("whatsappModal.operations.listenFromMe.desc")} enterDelay={500} arrow>
                              <Typography className={classes.permDesc}>
                                {i18n.t("whatsappModal.operations.listenFromMe.desc")}
                              </Typography>
                            </Tooltip>
                          </div>
                          <div className={classes.permSwitchWrap}>
                            <Switch
                              checked={Boolean(values.enableListenFromMe)}
                              color="primary"
                              onChange={(e) => setFieldValue("enableListenFromMe", e.target.checked)}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                        </Paper>
                      </Grid>

                      {/* Grupos como Ticket */}
                      <Grid item xs={12} sm={6}>
                        <Paper
                          elevation={0}
                          className={`${classes.permCard} ${values.groupAsTicket === "enabled" ? classes.permCardChecked : ""}`}
                          onClick={() => setFieldValue("groupAsTicket", values.groupAsTicket === "enabled" ? "disabled" : "enabled")}
                        >
                          <div
                            className={classes.permIconWrap}
                            style={{ color: "#ffa502", backgroundColor: "#ffa50218" }}
                          >
                            <ConfirmationNumberIcon fontSize="small" />
                          </div>
                          <div className={classes.permTextWrap}>
                            <Typography className={classes.permTitle}>
                              {i18n.t("whatsappModal.operations.groupAsTicket.title")}
                            </Typography>
                            <Tooltip title={i18n.t("whatsappModal.operations.groupAsTicket.desc")} enterDelay={500} arrow>
                              <Typography className={classes.permDesc}>
                                {i18n.t("whatsappModal.operations.groupAsTicket.desc")}
                              </Typography>
                            </Tooltip>
                          </div>
                          <div className={classes.permSwitchWrap}>
                            <Switch
                              checked={values.groupAsTicket === "enabled"}
                              color="primary"
                              onChange={(e) => setFieldValue("groupAsTicket", e.target.checked ? "enabled" : "disabled")}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                        </Paper>
                      </Grid>

                      {/* Modo Oficial Activo (si aplica) */}
                      {useWhatsappOfficial && channel === "whatsapp_oficial" && (
                        <Grid item xs={12} sm={6}>
                          <Paper
                            elevation={0}
                            className={`${classes.permCard} ${isOficial ? classes.permCardChecked : ""}`}
                            onClick={() => setIsOficial(!isOficial)}
                          >
                            <div
                              className={classes.permIconWrap}
                              style={{ color: "#1abc9c", backgroundColor: "#1abc9c18" }}
                            >
                              <VerifiedUserIcon fontSize="small" />
                            </div>
                            <div className={classes.permTextWrap}>
                              <Typography className={classes.permTitle}>
                                {i18n.t("whatsappModal.operations.isOficial.title")}
                              </Typography>
                              <Tooltip title={i18n.t("whatsappModal.operations.isOficial.desc")} enterDelay={500} arrow>
                                <Typography className={classes.permDesc}>
                                  {i18n.t("whatsappModal.operations.isOficial.desc")}
                                </Typography>
                              </Tooltip>
                            </div>
                            <div className={classes.permSwitchWrap}>
                              <Switch
                                checked={isOficial}
                                color="primary"
                                onChange={(e) => setIsOficial(e.target.checked)}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </div>
                          </Paper>
                        </Grid>
                      )}
                    </Grid>

                    {/* ENRUTAMIENTO Y DEPARTAMENTO */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.routing")}
                      </Typography>
                    </div>

                    <Paper elevation={0} className={classes.routingCard}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={6}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div
                              className={classes.permIconWrap}
                              style={{ color: "#3498db", backgroundColor: "#3498db18" }}
                            >
                              <CallSplitIcon fontSize="small" />
                            </div>
                            <div>
                              <Typography className={classes.permTitle}>
                                {i18n.t("whatsappModal.routing.title")}
                              </Typography>
                              <Typography className={classes.permDesc}>
                                {i18n.t("whatsappModal.routing.desc")}
                              </Typography>
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            required
                            error={touched.sendIdQueue && Boolean(errors.sendIdQueue)}
                          >
                            <InputLabel id="sendIdQueue-selection-label" required>
                              {i18n.t("whatsappModal.form.sendIdQueue")}
                            </InputLabel>
                            <Field
                              as={Select}
                              name="sendIdQueue"
                              id="sendIdQueue"
                              value={values.sendIdQueue || ""}
                              required
                              label={i18n.t("whatsappModal.form.sendIdQueue")}
                              labelId="sendIdQueue-selection-label"
                            >
                              {queues.map((queue) => (
                                <MenuItem key={queue.id} value={queue.id}>
                                  {queue.name}
                                </MenuItem>
                              ))}
                            </Field>
                            {touched.sendIdQueue && errors.sendIdQueue && (
                              <FormHelperText error style={{ marginLeft: 14 }}>
                                {errors.sendIdQueue}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Paper>

                    {/* SEGURIDAD Y API */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.security")}
                      </Typography>
                    </div>

                    {/* Tarjeta de Token API Interna */}
                    <Paper elevation={0} className={classes.tokenCard} style={{ marginBottom: 12 }}>
                        <div style={{ display: "flex", alignItems: "center", flex: 1, minWidth: 260 }}>
                          <div
                            className={classes.permIconWrap}
                            style={{ color: "#00a8ff", backgroundColor: "#00a8ff18" }}
                          >
                            <VpnKeyIcon fontSize="small" />
                          </div>
                          <div>
                            <Typography className={classes.permTitle}>
                              {i18n.t("whatsappModal.security.tokenTitle")}
                            </Typography>
                            <Typography className={classes.permDesc}>
                              {i18n.t("whatsappModal.security.tokenDesc")}
                            </Typography>
                          </div>
                        </div>

                        <div className={classes.tokenCode}>
                          {autoToken || "—"}
                        </div>

                        <div className={classes.tokenActions}>
                          <Button
                            onClick={handleCopyToken}
                            variant={copied ? "contained" : "outlined"}
                            color={copied ? "primary" : "default"}
                            style={copied ? { backgroundColor: "#2ed573", color: "#fff" } : {}}
                            className={classes.quickBtn}
                            startIcon={copied ? <CheckCircleIcon fontSize="small" /> : <FileCopyIcon fontSize="small" />}
                          >
                            {copied
                              ? i18n.t("whatsappModal.security.copied")
                              : i18n.t("whatsappModal.security.copyToken")}
                          </Button>

                          <Button
                            onClick={handleRefreshToken}
                            disabled={isSubmitting || brands.length === 0}
                            variant="outlined"
                            className={classes.quickBtn}
                            startIcon={<AutorenewIcon fontSize="small" style={{ color: "#2ed573" }} />}
                          >
                            {i18n.t("whatsappModal.security.regenerate")}
                          </Button>
                        </div>
                      </Paper>

                    {/* Campo Proxy Anti-Ban */}
                    <Grid container spacing={2} style={{ marginBottom: 8 }}>
                      <Grid item xs={12}>
                        <Field
                          as={TextField}
                          label={i18n.t("whatsappModal.security.proxyTitle")}
                          placeholder={i18n.t("whatsappModal.security.proxyPlaceholder")}
                          name="proxyUrl"
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          error={touched.proxyUrl && Boolean(errors.proxyUrl)}
                          helperText={
                            (touched.proxyUrl && errors.proxyUrl) ||
                            i18n.t("whatsappModal.security.proxyHelper")
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <VpnLockIcon fontSize="small" style={{ color: "rgba(255, 255, 255, 0.4)" }} />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>

                    {/* BLOQUES CONDICIONALES PARA API OFICIAL / YCLOUD / TELEGRAM */}
                    {(isOficial || values.channel === "whatsapp_oficial" || channel === "whatsapp_oficial") && (
                      <div style={{ marginTop: 12, marginBottom: 16, width: "100%" }}>
                        <div className={classes.sectionHeader}>
                          <Typography className={classes.sectionTitle}>
                            {i18n.t("whatsappModal.sections.officialConfig")}
                          </Typography>
                        </div>

                        {/* Facebook Login para API Oficial */}
                        {(isOficial || values.channel === "whatsapp_oficial" || channel === "whatsapp_oficial") && (
                          <Grid container spacing={1} style={{ marginBottom: 15 }}>
                            <Grid item xs={12}>
                              <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                onClick={() => handleFacebookLogin(values, setValues)}
                                disabled={isSubmitting || isExchangingCode || brands.length === 0}
                                style={{
                                  backgroundColor: "#1877F2",
                                  color: "white",
                                  textTransform: "none",
                                  fontWeight: "bold",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  padding: "10px 16px",
                                  borderRadius: "8px",
                                }}
                                startIcon={<FacebookIcon />}
                                fullWidth
                              >
                                {i18n.t("whatsappModal.buttons.facebookSignup")}
                              </Button>
                            </Grid>
                          </Grid>
                        )}

                        <Grid container spacing={2}>
                          <Grid item xs={12} md={6}>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.phone_number_id")}
                              name="phone_number_id"
                              InputLabelProps={{ shrink: true }}
                              error={touched.phone_number_id && Boolean(errors.phone_number_id)}
                              helperText={touched.phone_number_id && errors.phone_number_id}
                              variant="outlined"
                              margin="dense"
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.waba_id")}
                              name="waba_id"
                              InputLabelProps={{ shrink: true }}
                              error={touched.waba_id && Boolean(errors.waba_id)}
                              helperText={touched.waba_id && errors.waba_id}
                              variant="outlined"
                              margin="dense"
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.phone_number")}
                              name="phone_number"
                              InputLabelProps={{ shrink: true }}
                              error={touched.phone_number && Boolean(errors.phone_number)}
                              helperText={touched.phone_number && errors.phone_number}
                              variant="outlined"
                              margin="dense"
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.send_token")}
                              name="send_token"
                              InputLabelProps={{ shrink: true }}
                              error={touched.send_token && Boolean(errors.send_token)}
                              helperText={touched.send_token && errors.send_token}
                              variant="outlined"
                              margin="dense"
                            />
                          </Grid>
                        </Grid>
                      </div>
                    )}

                    {channel === "telegram" && (
                      <div style={{ marginTop: 12, marginBottom: 16, width: "100%" }}>
                        <div className={classes.sectionHeader}>
                          <Typography className={classes.sectionTitle}>
                            {i18n.t("whatsappModal.sections.telegramConfig")}
                          </Typography>
                        </div>

                        <Paper elevation={0} style={{ padding: "15px", marginBottom: "16px", backgroundColor: "rgba(0, 136, 204, 0.08)", borderLeft: "4px solid #0088cc", borderRadius: "8px" }}>
                          <Typography variant="subtitle2" style={{ fontWeight: "bold", color: "#0088cc", marginBottom: "8px" }}>
                            ¿Cómo obtener el Token de Telegram?
                          </Typography>
                          <Typography variant="body2" style={{ color: "rgba(255, 255, 255, 0.85)" }}>
                            1. Abre Telegram y busca a <strong>@BotFather</strong>.<br/>
                            2. Envíale el comando <strong>/newbot</strong> y sigue los pasos para darle nombre a tu bot.<br/>
                            3. Copia el <strong>HTTP API Token</strong> que te dará al final y pégalo aquí abajo.
                          </Typography>
                        </Paper>

                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.telegramToken")}
                              name="token"
                              InputLabelProps={{ shrink: true }}
                              error={touched.token && Boolean(errors.token)}
                              helperText={touched.token && errors.token}
                              variant="outlined"
                              margin="dense"
                            />
                          </Grid>
                        </Grid>
                      </div>
                    )}
                  </DialogContent>
                </TabPanel>
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"integrations"}
                >
                  <DialogContent dividers className={classes.customScrollbar}>
                    {/* FILAS DE ATENCIÓN DISPONIBLES */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.queues") || "Filas de Atención Disponibles"}
                      </Typography>
                    </div>

                    <Paper elevation={0} className={classes.cardBox}>
                      <div className={classes.cardHeader}>
                        <div
                          className={classes.permIconWrap}
                          style={{ color: "#3498db", backgroundColor: "#3498db18" }}
                        >
                          <AccountTreeIcon fontSize="small" />
                        </div>
                        <div>
                          <Typography className={classes.cardHeaderTitle}>
                            {i18n.t("whatsappModal.integrationsConfig.queuesTitle") || "Filas Asociadas a la Conexión"}
                          </Typography>
                          <Typography className={classes.cardHeaderDesc}>
                            {i18n.t("whatsappModal.integrationsConfig.queuesDesc") || "Seleccione los departamentos que tendrán acceso a recibir y transferir conversaciones en este canal"}
                          </Typography>
                        </div>
                      </div>
                      <QueueSelect
                        selectedQueueIds={selectedQueueIds}
                        onChange={(selectedIds) => handleChangeQueue(selectedIds)}
                      />
                    </Paper>

                    {/* INTEGRACIONES EXTERNAS Y SERVICIOS */}
                    {(showIntegrations || showWavoipCall) && (
                      <>
                        <div className={classes.sectionHeader}>
                          <Typography className={classes.sectionTitle}>
                            {i18n.t("whatsappModal.sections.integrations") || "Integraciones Externas y Servicios"}
                          </Typography>
                        </div>
                        <Grid container spacing={2} style={{ marginBottom: 14 }}>
                          {showIntegrations && (
                            <Grid item xs={12} sm={showWavoipCall ? 6 : 12}>
                              <Paper elevation={0} className={classes.cardBox} style={{ marginBottom: 0, height: "100%" }}>
                                <div className={classes.cardHeader}>
                                  <div
                                    className={classes.permIconWrap}
                                    style={{ color: "#9b59b6", backgroundColor: "#9b59b618" }}
                                  >
                                    <ExtensionIcon fontSize="small" />
                                  </div>
                                  <div>
                                    <Typography className={classes.cardHeaderTitle}>
                                      {i18n.t("whatsappModal.integrationsConfig.mainIntegrationTitle") || "Integración Principal"}
                                    </Typography>
                                    <Typography className={classes.cardHeaderDesc}>
                                      {i18n.t("whatsappModal.integrationsConfig.mainIntegrationDesc") || "Conecta un chatbot de Typebot, N8N o Webhook a nivel de canal"}
                                    </Typography>
                                  </div>
                                </div>
                                <FormControl
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                >
                                  <InputLabel id="integrationId-selection-label">
                                    {i18n.t("queueModal.form.integrationId")}
                                  </InputLabel>
                                  <Field
                                    as={Select}
                                    label={i18n.t("queueModal.form.integrationId")}
                                    name="integrationId"
                                    id="integrationId"
                                    labelId="integrationId-selection-label"
                                  >
                                    <MenuItem value={null}>{i18n.t("common.disabled")}</MenuItem>
                                    {integrations.map((integration) => (
                                      <MenuItem
                                        key={integration.id}
                                        value={integration.id}
                                      >
                                        {integration.name}
                                      </MenuItem>
                                    ))}
                                  </Field>
                                </FormControl>
                              </Paper>
                            </Grid>
                          )}

                          {showWavoipCall && (
                            <Grid item xs={12} sm={showIntegrations ? 6 : 12}>
                              <Paper elevation={0} className={classes.cardBox} style={{ marginBottom: 0, height: "100%" }}>
                                <div className={classes.cardHeader}>
                                  <div
                                    className={classes.permIconWrap}
                                    style={{ color: "#2ed573", backgroundColor: "#2ed57318" }}
                                  >
                                    <PhoneInTalkIcon fontSize="small" />
                                  </div>
                                  <div>
                                    <Typography className={classes.cardHeaderTitle}>
                                      Wavoip (Llamadas de Voz)
                                    </Typography>
                                    <Typography className={classes.cardHeaderDesc}>
                                      Identificador o clave de servicio de voz de Wavoip
                                    </Typography>
                                  </div>
                                </div>
                                <Field
                                  as={TextField}
                                  label="Wavoip Token / Clave"
                                  fullWidth
                                  name="wavoip"
                                  variant="outlined"
                                  margin="dense"
                                />
                              </Paper>
                            </Grid>
                          )}
                        </Grid>
                      </>
                    )}

                    {/* AUTOMATIZACIÓN AL CERRAR TICKET */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.closingIntegration") || "Automatización al Cerrar Ticket"}
                      </Typography>
                    </div>

                    <Paper elevation={0} className={classes.cardBox}>
                      <div className={classes.cardHeader}>
                        <div
                          className={classes.permIconWrap}
                          style={{ color: "#e67e22", backgroundColor: "#e67e2218" }}
                        >
                          <DoneAllIcon fontSize="small" />
                        </div>
                        <div>
                          <Typography className={classes.cardHeaderTitle}>
                            {i18n.t("whatsappModal.form.closingSettings") || "Automatización al Cerrar Ticket"}
                          </Typography>
                          <Typography className={classes.cardHeaderDesc}>
                            {i18n.t("whatsappModal.integrationsConfig.closingDesc") || "Dispara un flujo externo automáticamente cuando un operador o el sistema finaliza una conversación"}
                          </Typography>
                        </div>
                      </div>

                      <Grid spacing={2} container alignItems="center">
                        <Grid item xs={12} sm={triggerIntegrationOnClose ? 6 : 12}>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            fullWidth
                          >
                            <InputLabel id="triggerIntegrationOnClose-selection-label">
                              {i18n.t(
                                "whatsappModal.form.triggerIntegrationOnClose"
                              )}
                            </InputLabel>
                            <Field
                              onChange={handleChange}
                              value={triggerIntegrationOnClose}
                              as={Select}
                              label={i18n.t(
                                "whatsappModal.form.triggerIntegrationOnClose"
                              )}
                              name="triggerIntegrationOnClose"
                              id="triggerIntegrationOnClose"
                              labelId="triggerIntegrationOnClose-selection-label"
                            >
                              <MenuItem value={false}>
                                {i18n.t("whatsappModal.menuItem.disabled")}
                              </MenuItem>
                              <MenuItem value={true}>
                                {i18n.t("whatsappModal.menuItem.enabled")}
                              </MenuItem>
                            </Field>
                          </FormControl>
                        </Grid>

                        {triggerIntegrationOnClose && (
                          <Grid item xs={12} sm={6}>
                            <FormControl
                              variant="outlined"
                              margin="dense"
                              fullWidth
                            >
                              <InputLabel id="integrationType-selection-label">
                                {i18n.t("queueModal.form.closingIntegration") || "Flujo de Cierre"}
                              </InputLabel>
                              <Field
                                as={Select}
                                label={i18n.t("queueModal.form.closingIntegration") || "Flujo de Cierre"}
                                name="integrationType"
                                id="integrationType"
                                labelId="integrationType-selection-label"
                                value={integrationTypeId}
                                onChange={handleIntegrationTypeChange}
                              >
                                <MenuItem value={null}>{i18n.t("common.disabled")}</MenuItem>
                                {integrations
                                  .filter(
                                    (integration) =>
                                      integration.type === "n8n" ||
                                      integration.type === "typebot"
                                  )
                                  .map((integration) => (
                                    <MenuItem
                                      key={integration.id}
                                      value={integration.id}
                                    >
                                      {integration.name}
                                    </MenuItem>
                                  ))}
                              </Field>
                            </FormControl>
                          </Grid>
                        )}
                      </Grid>
                    </Paper>
                  </DialogContent>
                </TabPanel>
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"messages"}
                >
                  <DialogContent dividers className={classes.customScrollbar}>
                    {/* MENSAJES AUTOMÁTICOS DEL SISTEMA */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.messages") || "Mensajes Automáticos del Sistema"}
                      </Typography>
                    </div>


                    {/* MENSAGEM DE FORA DE EXPEDIENTE */}
                    <Paper elevation={0} className={classes.cardBox}>
                      <div className={classes.cardHeader}>
                        <div
                          className={classes.permIconWrap}
                          style={{ color: "#ffa502", backgroundColor: "#ffa50218" }}
                        >
                          <AccessTimeIcon fontSize="small" />
                        </div>
                        <div>
                          <Typography className={classes.cardHeaderTitle}>
                            {i18n.t("whatsappModal.form.outOfHoursMessage") || "Mensaje Fuera de Horario de Atención"}
                          </Typography>
                          <Typography className={classes.cardHeaderDesc}>
                            {i18n.t("whatsappModal.messagesHelp.outOfHours") || "Enviado cuando un cliente se comunica fuera de los horarios comerciales establecidos"}
                          </Typography>
                        </div>
                      </div>
                      <Field
                        as={TextField}
                        placeholder={i18n.t("whatsappModal.form.outOfHoursMessage")}
                        multiline
                        rows={3}
                        fullWidth
                        name="outOfHoursMessage"
                        error={
                          touched.outOfHoursMessage &&
                          Boolean(errors.outOfHoursMessage)
                        }
                        helperText={
                          touched.outOfHoursMessage &&
                          errors.outOfHoursMessage
                        }
                        variant="outlined"
                        margin="dense"
                      />
                    </Paper>

                    {/* RECHAZAR LLAMADAS AUTOMÁTICAMENTE (SOLO BAILEYS / QR) */}
                    {(channel === "whatsapp" || values?.channel === "whatsapp") && !isOficial && channel !== "whatsapp_oficial" && values?.channel !== "whatsapp_oficial" && (
                      <Paper elevation={0} className={classes.cardBox}>
                        <div className={classes.cardHeader} style={{ display: "flex", alignItems: "center" }}>
                          <div
                            className={classes.permIconWrap}
                            style={{ color: "#ff4757", backgroundColor: "#ff475718" }}
                          >
                            <PhoneInTalkIcon fontSize="small" />
                          </div>
                          <div style={{ flex: 1 }}>
                            <Typography className={classes.cardHeaderTitle}>
                              {i18n.t("whatsappModal.form.rejectCalls") || "Rechazar llamadas entrantes automáticamente"}
                            </Typography>
                            <Typography className={classes.cardHeaderDesc}>
                              {i18n.t("whatsappModal.messagesHelp.rejectCalls") || "Al activarse, las llamadas de voz y video a esta línea se cortarán de inmediato tras la primera timbrada y se enviará el mensaje automático."}
                            </Typography>
                          </div>
                          <Switch
                            checked={Boolean(values.rejectCalls)}
                            onChange={(e) => setFieldValue("rejectCalls", e.target.checked)}
                            color="primary"
                          />
                        </div>
                        {Boolean(values.rejectCalls) && (
                          <Field
                            as={TextField}
                            placeholder={i18n.t("whatsappModal.form.rejectCallMessagePlaceholder") || "En este momento no podemos atender tu llamada por favor deja tu mensaje."}
                            label={i18n.t("whatsappModal.form.rejectCallMessage") || "Mensaje para llamadas rechazadas"}
                            multiline
                            rows={3}
                            fullWidth
                            name="rejectCallMessage"
                            variant="outlined"
                            margin="dense"
                          />
                        )}
                      </Paper>
                    )}

                    {/* PERÍODO DE VACACIONES COLECTIVAS */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.vacation") || "Período de Vacaciones Colectivas"}
                      </Typography>
                    </div>

                    <Paper elevation={0} className={classes.cardBox}>
                      <div className={classes.cardHeader}>
                        <div
                          className={classes.permIconWrap}
                          style={{ color: "#e056fd", backgroundColor: "#e056fd18" }}
                        >
                          <BeachAccessIcon fontSize="small" />
                        </div>
                        <div>
                          <Typography className={classes.cardHeaderTitle}>
                            {i18n.t("whatsappModal.form.collectiveVacationMessage") || "Mensaje de Vacaciones Colectivas"}
                          </Typography>
                          <Typography className={classes.cardHeaderDesc}>
                            {i18n.t("whatsappModal.messagesHelp.vacation") || "Responde con este mensaje únicamente dentro del rango de fechas estipulado"}
                          </Typography>
                        </div>
                      </div>
                      <Field
                        as={TextField}
                        placeholder={i18n.t(
                          "whatsappModal.form.collectiveVacationMessage"
                        )}
                        multiline
                        rows={3}
                        fullWidth
                        name="collectiveVacationMessage"
                        error={
                          touched.collectiveVacationMessage &&
                          Boolean(errors.collectiveVacationMessage)
                        }
                        helperText={
                          touched.collectiveVacationMessage &&
                          errors.collectiveVacationMessage
                        }
                        variant="outlined"
                        margin="dense"
                        style={{ marginBottom: 16 }}
                      />

                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Field
                            fullWidth
                            as={TextField}
                            label={i18n.t(
                              "whatsappModal.form.collectiveVacationStart"
                            )}
                            type="date"
                            name="collectiveVacationStart"
                            required={
                              values.collectiveVacationMessage?.length > 0
                            }
                            inputProps={{
                              min: moment().add(-10, "days").format("YYYY-MM-DD"),
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            error={
                              touched.collectiveVacationStart &&
                              Boolean(errors.collectiveVacationStart)
                            }
                            helperText={
                              touched.collectiveVacationStart &&
                              errors.collectiveVacationStart
                            }
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Field
                            fullWidth
                            as={TextField}
                            label={i18n.t(
                              "whatsappModal.form.collectiveVacationEnd"
                            )}
                            type="date"
                            name="collectiveVacationEnd"
                            required={
                              values.collectiveVacationMessage?.length > 0
                            }
                            inputProps={{
                              min: moment().add(-10, "days").format("YYYY-MM-DD"),
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            error={
                              touched.collectiveVacationEnd &&
                              Boolean(errors.collectiveVacationEnd)
                            }
                            helperText={
                              touched.collectiveVacationEnd &&
                              errors.collectiveVacationEnd
                            }
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </DialogContent>
                </TabPanel>

                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"chatbot"}
                >
                  <DialogContent dividers className={classes.customScrollbar}>
                    {/* COMPORTAMIENTO Y REENVÍO DEL CHATBOT */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.chatbotBehavior") || "Comportamiento y Reenvío del Chatbot"}
                      </Typography>
                    </div>

                    <Paper elevation={0} className={classes.cardBox}>
                      <div className={classes.cardHeader}>
                        <div
                          className={classes.permIconWrap}
                          style={{ color: "#00a8ff", backgroundColor: "#00a8ff18" }}
                        >
                          <TimerIcon fontSize="small" />
                        </div>
                        <div>
                          <Typography className={classes.cardHeaderTitle}>
                            {i18n.t("whatsappModal.chatbotHelp.behaviorTitle") || "Ciclo de Vida y Reenvíos del Menú"}
                          </Typography>
                          <Typography className={classes.cardHeaderDesc}>
                            {i18n.t("whatsappModal.chatbotHelp.behaviorDesc") || "Configura los tiempos de espera entre menús y la reactivación de conversaciones"}
                          </Typography>
                        </div>
                      </div>

                      <Grid spacing={2} container>
                        {/* TEMPO PARA CRIAR NOVO TICKET */}
                        <Grid xs={12} sm={6} md={3} item>
                          <Field
                            as={TextField}
                            label={i18n.t(
                              "whatsappModal.form.timeCreateNewTicket"
                            )}
                            fullWidth
                            name="timeCreateNewTicket"
                            variant="outlined"
                            margin="dense"
                            error={
                              touched.timeCreateNewTicket &&
                              Boolean(errors.timeCreateNewTicket)
                            }
                            helperText={
                              touched.timeCreateNewTicket &&
                              errors.timeCreateNewTicket
                            }
                          />
                        </Grid>

                        {/* QUANTIDADE MÁXIMA DE VEZES QUE O CHATBOT VAI SER ENVIADO */}
                        <Grid xs={12} sm={6} md={3} item>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.maxUseBotQueues")}
                            fullWidth
                            name="maxUseBotQueues"
                            variant="outlined"
                            margin="dense"
                            error={
                              touched.maxUseBotQueues &&
                              Boolean(errors.maxUseBotQueues)
                            }
                            helperText={
                              touched.maxUseBotQueues && errors.maxUseBotQueues
                            }
                          />
                        </Grid>

                        {/* TEMPO PARA ENVIO DO CHATBOT */}
                        <Grid xs={12} sm={6} md={3} item>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.timeUseBotQueues")}
                            fullWidth
                            name="timeUseBotQueues"
                            variant="outlined"
                            margin="dense"
                            error={
                              touched.timeUseBotQueues &&
                              Boolean(errors.timeUseBotQueues)
                            }
                            helperText={
                              touched.timeUseBotQueues && errors.timeUseBotQueues
                            }
                          />
                        </Grid>

                        {/* TEMPO PARA RETORNAR A FILA */}
                        <Grid xs={12} sm={6} md={3} item>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.timeToReturnQueue")}
                            fullWidth
                            name="timeToReturnQueue"
                            variant="outlined"
                            margin="dense"
                            error={
                              touched.timeToReturnQueue &&
                              Boolean(errors.timeToReturnQueue)
                            }
                            helperText={
                              touched.timeToReturnQueue &&
                              errors.timeToReturnQueue
                            }
                          />
                        </Grid>
                      </Grid>
                    </Paper>

                    {/* CIERRE AUTOMÁTICO POR INACTIVIDAD */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.chatbotExpiration") || "Cierre Automático por Inactividad"}
                      </Typography>
                    </div>

                    <Paper elevation={0} className={classes.cardBox}>
                      <div className={classes.cardHeader}>
                        <div
                          className={classes.permIconWrap}
                          style={{ color: "#e74c3c", backgroundColor: "#e74c3c18" }}
                        >
                          <HourglassEmptyIcon fontSize="small" />
                        </div>
                        <div>
                          <Typography className={classes.cardHeaderTitle}>
                            {i18n.t("whatsappModal.chatbotHelp.expirationTitle") || "Expiración de Tickets por Inactividad"}
                          </Typography>
                          <Typography className={classes.cardHeaderDesc}>
                            {i18n.t("whatsappModal.chatbotHelp.expirationDesc") || "Cierra automáticamente los tickets estancados y envía un mensaje de finalización"}
                          </Typography>
                        </div>
                      </div>

                      <Grid spacing={2} container style={{ marginBottom: 14 }}>
                        {/* ENCERRAR CHATS ABERTOS APÓS X HORAS */}
                        <Grid xs={12} sm={6} item>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.expiresTicket")}
                            fullWidth
                            name="expiresTicket"
                            required={values.timeInactiveMessage > 0}
                            variant="outlined"
                            margin="dense"
                            error={
                              touched.expiresTicket &&
                              Boolean(errors.expiresTicket)
                            }
                            helperText={
                              touched.expiresTicket && errors.expiresTicket
                            }
                          />
                        </Grid>

                        {/* CRITERIO DE EXPIRACIÓN */}
                        <Grid xs={12} sm={6} item>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            fullWidth
                          >
                            <InputLabel id="whenExpiresTicket-selection-label">
                              {i18n.t("whatsappModal.form.whenExpiresTicket")}
                            </InputLabel>
                            <Field
                              as={Select}
                              label={i18n.t(
                                "whatsappModal.form.whenExpiresTicket"
                              )}
                              labelId="whenExpiresTicket-selection-label"
                              id="whenExpiresTicket"
                              name="whenExpiresTicket"
                            >
                              <MenuItem value={"0"}>
                                {i18n.t(
                                  "whatsappModal.form.closeLastMessageOptions1"
                                )}
                              </MenuItem>
                              <MenuItem value={"1"}>
                                {i18n.t(
                                  "whatsappModal.form.closeLastMessageOptions2"
                                )}
                              </MenuItem>
                            </Field>
                          </FormControl>
                        </Grid>
                      </Grid>

                      {/* MENSAGEM POR INATIVIDADE*/}
                      <Field
                        as={TextField}
                        label={i18n.t(
                          "whatsappModal.form.expiresInactiveMessage"
                        )}
                        placeholder={i18n.t("whatsappModal.form.expiresInactiveMessage")}
                        multiline
                        rows={3}
                        fullWidth
                        name="expiresInactiveMessage"
                        error={
                          touched.expiresInactiveMessage &&
                          Boolean(errors.expiresInactiveMessage)
                        }
                        helperText={
                          touched.expiresInactiveMessage &&
                          errors.expiresInactiveMessage
                        }
                        variant="outlined"
                        margin="dense"
                      />
                    </Paper>

                    {/* AVISOS PREVIOS Y FLUJO DE INACTIVIDAD */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.chatbotInactivity") || "Avisos Previos y Flujo de Inactividad"}
                      </Typography>
                    </div>

                    <Paper elevation={0} className={classes.cardBox}>
                      <div className={classes.cardHeader}>
                        <div
                          className={classes.permIconWrap}
                          style={{ color: "#f39c12", backgroundColor: "#f39c1218" }}
                        >
                          <CallSplitIcon fontSize="small" />
                        </div>
                        <div>
                          <Typography className={classes.cardHeaderTitle}>
                            {i18n.t("whatsappModal.chatbotHelp.inactivityTitle") || "Alertas de Inactividad y Flujo"}
                          </Typography>
                          <Typography className={classes.cardHeaderDesc}>
                            {i18n.t("whatsappModal.chatbotHelp.inactivityDesc") || "Advierte al contacto antes de que el chat expire y opcionalmente transfiérelo a un flujo"}
                          </Typography>
                        </div>
                      </div>

                      <Grid spacing={2} container style={{ marginBottom: 14 }}>
                        <Grid xs={12} sm={4} item>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.timeInactiveMessage")}
                            fullWidth
                            name="timeInactiveMessage"
                            variant="outlined"
                            margin="dense"
                            error={
                              touched.timeInactiveMessage &&
                              Boolean(errors.timeInactiveMessage)
                            }
                            helperText={
                              touched.timeInactiveMessage &&
                              errors.timeInactiveMessage
                            }
                          />
                        </Grid>
                        <Grid xs={12} sm={8} item>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.inactiveMessage")}
                            placeholder={i18n.t("whatsappModal.form.inactiveMessage")}
                            fullWidth
                            name="inactiveMessage"
                            error={
                              touched.inactiveMessage &&
                              Boolean(errors.inactiveMessage)
                            }
                            helperText={
                              touched.inactiveMessage && errors.inactiveMessage
                            }
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                      </Grid>

                      {user.showFlow === "enabled" && (
                        <Grid spacing={2} container alignItems="center">
                          <Grid xs={12} sm={4} item>
                            <Field
                              as={TextField}
                              label={i18n.t("whatsappModal.form.flowInactiveTime")}
                              fullWidth
                              name="flowInactiveTime"
                              variant="outlined"
                              margin="dense"
                              error={
                                touched.flowIdInactiveTime &&
                                Boolean(errors.flowIdInactiveTime)
                              }
                              helperText={
                                touched.flowIdInactiveTime &&
                                errors.flowIdInactiveTime
                              }
                            />
                          </Grid>
                          <Grid xs={12} sm={4} item>
                            <Field
                              as={TextField}
                              label={i18n.t(
                                "whatsappModal.form.maxUseInactiveTime"
                              )}
                              fullWidth
                              name="maxUseInactiveTime"
                              variant="outlined"
                              margin="dense"
                              error={
                                touched.maxUseInactiveTime &&
                                Boolean(errors.maxUseInactiveTime)
                              }
                              helperText={
                                touched.maxUseInactiveTime &&
                                errors.maxUseInactiveTime
                              }
                            />
                          </Grid>
                          <Grid xs={12} sm={4} item>
                            <FormControl
                              variant="outlined"
                              margin="dense"
                              fullWidth
                            >
                              <InputLabel id="flowIdInactiveTime-selection-label">
                                {i18n.t("flowDefault.title") || "Flujo por Inactividad"}
                              </InputLabel>
                              <Select
                                name="flowIdInactiveTime"
                                value={values.flowIdInactiveTime || ""}
                                label={i18n.t("flowDefault.title") || "Flujo por Inactividad"}
                                onChange={(e) => {
                                  setFieldValue("flowIdInactiveTime", e.target.value);
                                }}
                                id="flowIdInactiveTime"
                                labelId="flowIdInactiveTime-selection-label"
                              >
                                <MenuItem value={null}>{i18n.t("common.disabled")}</MenuItem>
                                {webhooks.map((webhook) => (
                                  <MenuItem key={webhook.id} value={webhook.id}>
                                    {webhook.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      )}
                    </Paper>
                  </DialogContent>
                </TabPanel>

                {/* NPS */}
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"nps"}
                >
                  <DialogContent dividers className={classes.customScrollbar}>
                    {/* SECCIÓN EVALUACIÓN DE SATISFACCIÓN */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.npsMessage") || "Encuesta de Satisfacción (NPS)"}
                      </Typography>
                    </div>

                    {/* MENSAGEM DE AVALIAÇAO*/}
                    <Paper elevation={0} className={classes.cardBox}>
                      <div className={classes.cardHeader}>
                        <div
                          className={classes.permIconWrap}
                          style={{ color: "#f1c40f", backgroundColor: "#f1c40f18" }}
                        >
                          <StarIcon fontSize="small" />
                        </div>
                        <div>
                          <Typography className={classes.cardHeaderTitle}>
                            {i18n.t("whatsappModal.form.ratingMessage") || "Pregunta de Evaluación"}
                          </Typography>
                          <Typography className={classes.cardHeaderDesc}>
                            {i18n.t("whatsappModal.npsHelp.ratingDesc") || "Mensaje enviado solicitando calificación al resolver la conversación (Escala de 0 a 10)"}
                          </Typography>
                        </div>
                      </div>
                      <Field
                        as={TextField}
                        placeholder={i18n.t("whatsappModal.form.ratingMessage")}
                        multiline
                        rows={3}
                        fullWidth
                        name="ratingMessage"
                        error={
                          touched.ratingMessage && Boolean(errors.ratingMessage)
                        }
                        helperText={
                          touched.ratingMessage && errors.ratingMessage
                        }
                        variant="outlined"
                        margin="dense"
                      />
                    </Paper>

                    {/* PARÁMETROS Y EXPIRACIÓN */}
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("whatsappModal.sections.npsParams") || "Parámetros y Expiración de NPS"}
                      </Typography>
                    </div>

                    <Paper elevation={0} className={classes.cardBox}>
                      <div className={classes.cardHeader}>
                        <div
                          className={classes.permIconWrap}
                          style={{ color: "#3498db", backgroundColor: "#3498db18" }}
                        >
                          <TimerIcon fontSize="small" />
                        </div>
                        <div>
                          <Typography className={classes.cardHeaderTitle}>
                            {i18n.t("whatsappModal.npsHelp.paramsTitle") || "Parámetros de la Encuesta"}
                          </Typography>
                          <Typography className={classes.cardHeaderDesc}>
                            {i18n.t("whatsappModal.npsHelp.paramsDesc") || "Configura la insistencia del envío y el tiempo de tolerancia para responder"}
                          </Typography>
                        </div>
                      </div>

                      <Grid container spacing={2}>
                        {/* QUANTIDADE MÁXIMA DE VEZES QUE O NPS VAI SER ENVIADO */}
                        <Grid item xs={12} sm={6}>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.maxUseBotQueuesNPS")}
                            fullWidth
                            name="maxUseBotQueuesNPS"
                            variant="outlined"
                            margin="dense"
                            error={
                              touched.maxUseBotQueuesNPS &&
                              Boolean(errors.maxUseBotQueuesNPS)
                            }
                            helperText={
                              touched.maxUseBotQueuesNPS &&
                              errors.maxUseBotQueuesNPS
                            }
                          />
                        </Grid>

                        {/* ENCERRAR CHATS NPS APÓS X Minutos */}
                        <Grid item xs={12} sm={6}>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.expiresTicketNPS")}
                            fullWidth
                            name="expiresTicketNPS"
                            variant="outlined"
                            margin="dense"
                            error={
                              touched.expiresTicketNPS &&
                              Boolean(errors.expiresTicketNPS)
                            }
                            helperText={
                              touched.expiresTicketNPS && errors.expiresTicketNPS
                            }
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </DialogContent>
                </TabPanel>

                {/* Flowbuilder */}
                {showIntegrations && user.showFlow === "enabled" && (
                  <>
                    <TabPanel
                      className={classes.container}
                      value={tab}
                      name={"flowbuilder"}
                    >
                      <DialogContent dividers className={classes.customScrollbar}>
                        {/* SECCIÓN FLUJO DE BIENVENIDA */}
                        <div className={classes.sectionHeader}>
                          <Typography className={classes.sectionTitle}>
                            {i18n.t("whatsappModal.sections.flowWelcome") || "Flujo Inicial de Bienvenida"}
                          </Typography>
                        </div>

                        <Paper elevation={0} className={classes.cardBox}>
                          <div className={classes.cardHeader}>
                            <div
                              className={classes.permIconWrap}
                              style={{ color: "#2ed573", backgroundColor: "#2ed57318" }}
                            >
                              <PlayCircleOutlineIcon fontSize="small" />
                            </div>
                            <div>
                              <Typography className={classes.cardHeaderTitle}>
                                {i18n.t("flowDefault.welcome") || "Bienvenido de Nuevo"}
                              </Typography>
                              <Typography className={classes.cardHeaderDesc}>
                                {i18n.t("flowDefault.welcomeDescription") || "Este flujo se dispara solo para nuevos contactos que no están en tu lista y enviaron un mensaje"}
                              </Typography>
                            </div>
                          </div>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            fullWidth
                          >
                            <InputLabel id="flowIdWelcome-selection-label">
                              {i18n.t("flowDefault.title") || "Flujo de Bienvenida"}
                            </InputLabel>
                            <Select
                              name="flowIdWelcome"
                              value={values.flowIdWelcome || "DISABLED"}
                              label={i18n.t("flowDefault.title") || "Flujo de Bienvenida"}
                              onChange={(e) => {
                                setFieldValue("flowIdWelcome", e.target.value);
                              }}
                              id="flowIdWelcome"
                              labelId="flowIdWelcome-selection-label"
                            >
                              <MenuItem value={"DISABLED"}>{i18n.t("common.disabled")}</MenuItem>
                              {webhooks.map((webhook) => (
                                <MenuItem key={webhook.id} value={webhook.id}>
                                  {webhook.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Paper>

                        {/* SECCIÓN FLUJO POR DEFECTO */}
                        <div className={classes.sectionHeader}>
                          <Typography className={classes.sectionTitle}>
                            {i18n.t("whatsappModal.sections.flowDefault") || "Flujo de Respuesta por Defecto"}
                          </Typography>
                        </div>

                        <Paper elevation={0} className={classes.cardBox}>
                          <div className={classes.cardHeader}>
                            <div
                              className={classes.permIconWrap}
                              style={{ color: "#9b59b6", backgroundColor: "#9b59b618" }}
                            >
                              <HelpOutlineIcon fontSize="small" />
                            </div>
                            <div>
                              <Typography className={classes.cardHeaderTitle}>
                                {i18n.t("flowDefault.default") || "Por Defecto"}
                              </Typography>
                              <Typography className={classes.cardHeaderDesc}>
                                {i18n.t("flowDefault.defaultDescription") || "Se envía con cualquier carácter diferente de una palabra clave o cuando no hay coincidencia"}
                              </Typography>
                            </div>
                          </div>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            fullWidth
                          >
                            <InputLabel id="flowIdNotPhrase-selection-label">
                              {i18n.t("flowDefault.title") || "Flujo por Defecto"}
                            </InputLabel>
                            <Select
                              name="flowIdNotPhrase"
                              value={values.flowIdNotPhrase || "DISABLED"}
                              label={i18n.t("flowDefault.title") || "Flujo por Defecto"}
                              onChange={(e) => {
                                setFieldValue("flowIdNotPhrase", e.target.value);
                              }}
                              id="flowIdNotPhrase"
                              labelId="flowIdNotPhrase-selection-label"
                            >
                              <MenuItem value={"DISABLED"}>{i18n.t("common.disabled")}</MenuItem>
                              {webhooks.map((webhook) => (
                                <MenuItem key={webhook.id} value={webhook.id}>
                                  {webhook.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Paper>
                      </DialogContent>
                    </TabPanel>
                  </>
                )}

                {/* Schedules */}
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"schedules"}
                >
                  {tab === "schedules" && (
                    <DialogContent dividers className={classes.customScrollbar}>
                      <Paper elevation={0} className={classes.cardBox} style={{ padding: 20 }}>
                        <SchedulesForm
                          loading={false}
                          onSubmit={handleSaveSchedules}
                          initialValues={schedules}
                          labelSaveButton={i18n.t("whatsappModal.buttons.okAdd")}
                        />
                      </Paper>
                    </DialogContent>
                  )}
                </TabPanel>
              </Paper>
              <DialogActions>
                <Button
                  onClick={handleClose}
                  color="secondary"
                  disabled={isSubmitting}
                  variant="outlined"
                >
                  {i18n.t("whatsappModal.buttons.cancel")}
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  disabled={isSubmitting}
                  variant="contained"
                  className={classes.btnWrapper}
                >
                  {whatsAppId
                    ? i18n.t("whatsappModal.buttons.okEdit")
                    : i18n.t("whatsappModal.buttons.okAdd")}
                  {isSubmitting && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div >
  );
};

export default React.memo(WhatsAppModal);
